// Utility to check Firebase Authentication configuration
import { auth } from "../firebase";

/**
 * Verifies if Firebase Authentication is properly configured
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const checkFirebaseAuth = async () => {
  try {
    // Check if auth object exists
    if (!auth) {
      return {
        success: false,
        message: "Firebase Auth object is not initialized"
      };
    }

    // Try to get the current user (this will fail if auth is not configured)
    // We're not actually using the user, just checking if auth is accessible
    // eslint-disable-next-line no-unused-vars
    const currentUser = auth.currentUser;
    
    // Check if auth has the necessary methods
    if (typeof auth.app === 'undefined') {
      return {
        success: false,
        message: "Firebase Auth app reference is missing"
      };
    }

    // Check project configuration
    const projectId = auth.app.options.projectId;
    if (!projectId) {
      return {
        success: false,
        message: "Firebase project ID is missing"
      };
    }

    return {
      success: true,
      message: `Firebase Auth is initialized for project: ${projectId}`
    };
  } catch (error) {
    return {
      success: false,
      message: `Firebase Auth check failed: ${error.message}`,
      error: error
    };
  }
};

/**
 * Logs detailed Firebase configuration for debugging
 */
export const logFirebaseConfig = () => {
  try {
    if (auth && auth.app) {
      const config = auth.app.options;
      console.group("🔍 Firebase Configuration Check");
      console.log("Project ID:", config.projectId);
      console.log("Auth Domain:", config.authDomain);
      console.log("API Key:", config.apiKey ? `${config.apiKey.substring(0, 10)}...` : "Not set");
      console.log("App ID:", config.appId);
      console.log("Auth Object:", auth ? "✅ Initialized" : "❌ Not initialized");
      console.groupEnd();
    } else {
      console.error("❌ Firebase Auth is not properly initialized");
    }
  } catch (error) {
    console.error("❌ Error checking Firebase config:", error);
  }
};

